import { useLocale } from '@gov-nx/core/service';
import { useMojeAutorizaceSeznamContext } from '@gov-nx/module/page';
import {
	ContentLayout,
	ErrorStatusBanner,
	InfoBanner,
	Pagination,
	Tile,
	Tiles,
} from '@gov-nx/ui/web';
import { toDateReadable } from '@gov-nx/utils/common';
import { pageRouteResolver, scrollToTop } from '@gov-nx/web';
import { MyAuthorizationListSkeleton } from './MyAuthorizationsListSkeleton';

export const MyAuthorizationListView = () => {
	const {
		code,
		isNoSubmissions,
		form602Submissions,
		number602Submissions,
		currentPage,
		filter,
		controls,
		goToPage,
	} = useMojeAutorizaceSeznamContext();
	const { t } = useLocale(code);

	if (controls.initialLoading || controls.processLoading) {
		return <MyAuthorizationListSkeleton />;
	}

	if (controls.initialError) {
		return <ErrorStatusBanner code={code} />;
	}

	if (isNoSubmissions) {
		return (
			<ContentLayout>
				<InfoBanner
					headline={t('stav.chyba.zadne-autorizace')}
					text={t('stav.chyba.nenasli-jsme-autorizace')}
				/>
			</ContentLayout>
		);
	}

	return (
		<>
			<Tiles marginTop="l">
				{form602Submissions.map((submission) => (
					<Tile
						key={submission.formularPodaniId}
						to={pageRouteResolver('moje-podani.autorizace.detail', {
							formularPodaniId: submission.formularPodaniId,
						})}
						// TODO: tady prozatim jako jmeno formId, protoze nazev nechodi
						name={submission.nazev ?? submission.formId ?? ''}
						date={
							submission.datumACasVytvoreni &&
							toDateReadable(submission.datumACasVytvoreni)
						}
						icon={{ name: 'chevron-right', type: 'components' }}
					/>
				))}
			</Tiles>
			{number602Submissions > filter.pocet ? (
				<Pagination
					color="primary"
					size="m"
					onPage={(page) => {
						scrollToTop();
						goToPage(page);
					}}
					current={currentPage}
					pageSize={filter.pocet}
					total={number602Submissions}
					wcag-label={t('strankovani')}
				/>
			) : null}
		</>
	);
};
